var Vendd = (function (Vendd) {
    'use strict';

    Vendd.ScrollList = (function (ScrollList) {

        ScrollList.Messages = (function (Messages) {

            Messages.GetNextPage = function (list, serviceConfiguration,type) {
                var data = {
                    type:type,
                    list: list,
                    serviceConfiguration: serviceConfiguration
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetNextPage", data);
            };
            Messages.GetNextPage.className = "Vendd.ScrollList.Messages.GetNextPage";

            Messages.GetPreviousPage = function (list, serviceConfiguration, type) {
                var data = {
                    list: list,
                    serviceConfiguration: serviceConfiguration
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetPreviousPage", data);
            };
            Messages.GetPreviousPage.className = "Vendd.ScrollList.Messages.GetPreviousPage";

            Messages.GetCurrentPage = function (list, serviceConfiguration, type) {
                var data = {
                    type: type,
                    list: list,
                    serviceConfiguration: serviceConfiguration
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetCurrentPage", data);
            };
            Messages.GetCurrentPage.className = "Vendd.ScrollList.Messages.GetCurrentPage";

            Messages.GetPageSuccess = function (list, model, position, type) {
                var data = {
                    type: type,
                    list: list,
                    model: model,
                    position: position
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetPageSuccess", data);
            };
            Messages.GetPageSuccess.className = "Vendd.ScrollList.Messages.GetPageSuccess";

            Messages.GetCurrentPageSuccess = function (list, model, position, type) {
                var data = {
                    type: type,
                    list: list,
                    model: model,
                    position: position
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetCurrentPageSuccess", data);
            };
            Messages.GetCurrentPageSuccess.className = "Vendd.ScrollList.Messages.GetCurrentPageSuccess";

            Messages.GetNextPageFailure = function (list, response) {
                response.data = JSON.parse(response.data);
                var data = {
                    list: list,
                    response: response
                };

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetNextPageFailure", data);
            };
            Messages.GetNextPageFailure.className = "Vendd.ScrollList.Messages.GetNextPageFailure";

            Messages.GetPreviousPageFailure = function (list, response) {
            	response.data = JSON.parse(response.data);
            	var data = {
            		list: list,
            		response: response
            	};

            	Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetPreviousPageFailure", data);
            };
            Messages.GetPreviousPageFailure.className = "Vendd.ScrollList.Messages.GetPreviousPageFailure";

            Messages.GetCurrentPageFailure = function (list, response) {
                response.data = JSON.parse(response.data);
                var data = {
                    list: list,
                    response: response
                };

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetCurrentPageFailure", data);
            };
            Messages.GetCurrentPageFailure.className = "Vendd.ScrollList.Messages.GetCurrentPageFailure";

            Messages.GetClientProductListData = function (request) {
                var data = {
                    itemIds: request.itemIds,
                    fetchPrices: request.fetchPrices,
                    fetchAvailabilities: request.fetchAvailabilities,
                    fetchStock: request.fetchStock
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetClientProductListData", data);
            }
            Messages.GetClientProductListData.className = "Vendd.ScrollList.Messages.GetClientProductListData";

            Messages.GetClientProductListDataSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetClientProductListDataSuccess", response);
            };
            Messages.GetClientProductListDataSuccess.className = "Vendd.ScrollList.Messages.GetClientProductListDataSuccess";

            Messages.GetClientProductListDataFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetClientProductListDataFailure", response);
            };
            Messages.GetClientProductListDataFailure.className = "Vendd.ScrollList.Messages.GetClientProductListDataFailure";

            return Messages;

        })(ScrollList.Messages || {});

        return ScrollList;

    })(Vendd.ScrollList || {});

    return Vendd;

})(Vendd || {});